<template>
    <div class="content-wapper">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">检验检测服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/jyjcfw/tzsbjc' }">特种设备检测</el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.title}}</h1>
            <el-row class="soure">
                <span style="padding-right: 105px;">发布时间：{{ parseTime(detail.fbTime, '{y}-{m}-{d}') }}</span><span style="padding-right: 105px;">访问量：{{browseCount}}</span><span>来源：{{fbDept}}</span>
            </el-row>
            <div v-html="detail.content" class="eidt-content"></div>
        </el-row>

    </div>
</template>

<script>
    import { getBrowseCount } from "@/api/basedata/records";
    import {getTzsbTzgg} from "@/api/jyjcfw/tzsbTzgg";
    export default {
        name: "detail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                type:undefined,
                detail:{},
                browseCount:undefined,
                fbDept: '威海市市场监督管理局',
                ywViews:{
                    busRecid:undefined,
                    busTableName:'yw_jyjcfw_tzsb_tzgg',
                },
            }
        },
        created() {
            this.recid = this.$route.params && this.$route.params.recid;
            this.getDetail();
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getDetail();
            },
            getDetail(){
                let recid = this.recid;
                getTzsbTzgg(recid).then(response => {
                    this.detail = response.data;
                    this.getBrowseData();
                });
            },
            getBrowseData(){
                this.ywViews.busRecid= this.recid;
                getBrowseCount(this.ywViews).then(response => {
                    this.browseCount=response;
                })
            }
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .content{
        border: 1px solid #cccccc;
        padding:20px 80px;
    }
    .soure{
        background-color:#f3f3f3;
        padding:10px;
        margin: 25px 0;
    }
</style>